<template>
  <div id="q-app">
    <q-layout
      view="lHh lpR fFf"
      style="
        max-height: calc(100vh - 100px);
        min-height: calc(100vh - 100px) !important;
      "
    >
      <app-bar />
      <q-page-container
        class="bg-secondary"
        :style="`height: calc(100vh - 130px)`"
      >
        <q-scroll-area :style="`height: calc(100vh - 80px) !important;`">
          <router-view
            :class="{
              'q-pa-md': !$route.meta.fullscreen && this.$q.screen.gt.sm,
            }"
          />
        </q-scroll-area>
      </q-page-container>
    </q-layout>
  </div>
</template>

<script>
  import { auth } from "@/firebase.js";
  import { mapGetters } from "vuex";
  import AppBar from "@/components/AppBar";
  import { colors } from "quasar";
  import api from "./api";

  export default {
    components: {
      AppBar,
    },
    computed: {
      ...mapGetters({
        fullLoading: "settings/fullLoading",
        currentUser: "auth/currentUser",
        currentUserData: "auth/currentUserData",
        offlineMode: "offlineMode",
        darkMode: "settings/darkMode",
      }),
    },
    data: () => ({
      training: false,
    }),
    watch: {
      currentUser: function (oldData, newData) {
        this.checkLoggedIn();
      },
      $route: function (newRoute, oldRoute) {
        this.checkLoggedIn();
      },
      currentUserData: function () {},
      darkMode: function () {
        this.themeInit();
      },
    },
    mounted() {
      console.log(1);
      this.checkLoggedIn();
      this.themeInit();
      this.training = api.defaults.baseURL.includes("_training");
    },
    methods: {
      themeInit() {
        this.$q.dark.set(this.darkMode);
        if (this.$q.dark.isActive) {
          colors.setBrand("secondary", "#252525");
          colors.setBrand("headerColor", "#222222");
          colors.setBrand("headerButton", "#ffffff");
        } else {
          colors.setBrand("secondary", "#edf5f8");
          colors.setBrand("headerColor", "#ffffff");
          colors.setBrand("headerButton", "#222222");
        }
      },
      checkLoggedIn() {
        // var ts = Math.round(new Date().getTime() / 1000);
        // if (this.currentUser != null && this.currentUser != "loading") {
        //   if (this.$route.path === "/login") {
        //     this.$router.push("/");
        //   }
        // } else if (this.currentUser != "loading") {
        //   if (this.$route.path != "/login") {
        //     this.$router.push("/login");
        //   }
        // }
      },
    },
  };
</script>

<style lang="scss">
  ::-webkit-scrollbar {
    width: 5px;
    height: 10px;
  }
  ::-webkit-scrollbar-track {
    background: $scrollbarTrack;
  }
  ::-webkit-scrollbar-thumb {
    background: $scrollbarThumb;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: $scrollbarHover;
  }
  .loaderOverlay {
    z-index: 9999;
    background: $accent;
    width: 100vw;
    height: 100vh;
    position: fixed;
  }
  .lds-ripple {
    top: calc(50vh - 40px);
    left: calc(50vw - 40px);
    display: inline-block;
    position: fixed;
    width: 80px;
    height: 80px;
  }
  .lds-ripple div {
    position: absolute;
    border: 4px solid $primary;
    opacity: 1;
    border-radius: 50%;
    animation: lds-ripple 1s cubic-bezier(0, 0.2, 0.8, 1) infinite;
  }
  .lds-ripple div:nth-child(2) {
    animation-delay: -0.5s;
  }
  .swal2-container {
    z-index: 10060 !important;
  }
  .q-header {
    position: absolute !important;
  }
  .q-page {
    min-height: calc(100vh - 150px) !important;
    max-height: calc(100vh - 150px) !important;
  }
  @keyframes lds-ripple {
    0% {
      top: 36px;
      left: 36px;
      width: 0;
      height: 0;
      opacity: 1;
    }
    100% {
      top: 0px;
      left: 0px;
      width: 72px;
      height: 72px;
      opacity: 0;
    }
  }
</style>
